import type * as Types from '../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type JoyFeatureCheckoutMarketsQueryVariables = Types.Exact<{
  featureType: Types.JoyFeatureType;
}>;

export type JoyFeatureCheckoutMarketsQuery = {
  __typename?: 'Query';
  joyFeatureCheckoutMarkets: Array<{ __typename?: 'JoyFeatureCheckoutMarket'; countryCode: string; currencyISO4217: string; minorUnitDigits: number; priceInMinorUnits: number }>;
};

export const JoyFeatureCheckoutMarketsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'JoyFeatureCheckoutMarkets' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'featureType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'JoyFeatureType' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'joyFeatureCheckoutMarkets' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'featureType' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'featureType' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currencyISO4217' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minorUnitDigits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priceInMinorUnits' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useJoyFeatureCheckoutMarketsQuery__
 *
 * To run a query within a React component, call `useJoyFeatureCheckoutMarketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJoyFeatureCheckoutMarketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJoyFeatureCheckoutMarketsQuery({
 *   variables: {
 *      featureType: // value for 'featureType'
 *   },
 * });
 */
export function useJoyFeatureCheckoutMarketsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<JoyFeatureCheckoutMarketsQuery, JoyFeatureCheckoutMarketsQueryVariables>) {
  return ApolloReactHooks.useQuery<JoyFeatureCheckoutMarketsQuery, JoyFeatureCheckoutMarketsQueryVariables>(JoyFeatureCheckoutMarketsDocument, baseOptions);
}
export function useJoyFeatureCheckoutMarketsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<JoyFeatureCheckoutMarketsQuery, JoyFeatureCheckoutMarketsQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<JoyFeatureCheckoutMarketsQuery, JoyFeatureCheckoutMarketsQueryVariables>(JoyFeatureCheckoutMarketsDocument, baseOptions);
}
export type JoyFeatureCheckoutMarketsQueryHookResult = ReturnType<typeof useJoyFeatureCheckoutMarketsQuery>;
export type JoyFeatureCheckoutMarketsLazyQueryHookResult = ReturnType<typeof useJoyFeatureCheckoutMarketsLazyQuery>;
export type JoyFeatureCheckoutMarketsQueryResult = Apollo.QueryResult<JoyFeatureCheckoutMarketsQuery, JoyFeatureCheckoutMarketsQueryVariables>;
